// Vocabulário e formatação do módulo Créditos de Clientes — uma fonte só para
// as abas (espelha resources/lang/pt-BR/creditos.php do backend: o termo
// técnico "diferença" vira "troco" para quem lê de fora).

export const OPERACOES = {
  RESERVA: "Crédito separado para o pedido",
  AJUSTE_VALOR: "Crédito usado em parte",
  GERACAO_DIFERENCA: "Troco devolvido como crédito",
  CONFIRMACAO: "Abatido no pedido",
  LIBERACAO: "Devolvido ao cliente",
  BAIXA_DIFERENCA: "Troco recolhido",
};

export const SITUACOES = {
  ABERTA: "Aguardando pedido",
  CONFIRMADA: "Abatido no pedido",
  LIBERADA: "Devolvido ao cliente",
  FALHA: "Não concluída",
};

// O filtro global `monetary` tem o separador de milhar quebrado para valores
// acima de 100 mil; até ele ser corrigido, o módulo formata via Intl.
export function formatMoney(valor) {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
